<template>
  <div class="box" id="qa">    
    <div class="box-tittel">      
        <h1 class="text-center">{{this.tittle}}</h1>      
    </div>
    <br />
    <div class="box-100">
      <div class="box-55">
        <QuestionsList :questionList="$store.getters.getQasFiltered" :filter="$route.params.filter" />
      </div>
      <div class="box-45">
        <QuestionsForm
          :tags="$store.getters.getTasks"
          :qa="$store.getters.getQASelected"
          :update="$store.getters.getIsQAUpdate"
        />
      </div>

    </div>
  </div>
</template>

<script>
import QuestionsList from "./../components/questions/QuestionsList.vue";
import QuestionsForm from "./../components/questions/QuestionForm.vue";
//import AppHeaderOperario from "./../components/HeaderOperario.vue";
//import { getAllQAs, getAllCategories } from "./../api/conection";

export default {
  name: "Qa",
  components: {
    QuestionsList,
    QuestionsForm,
    //AppHeaderOperario
  },
  data() {
    return {
      tittle: "Preguntas"
    };
  },
  /*
  mounted() {
    getAllQAs()
      .then(qas => {
        if (!qas.message) this.$store.dispatch("setQAsAction", qas);
      })
      .catch(err => {
        console.log(err);
      }),
      
  }*/
};
</script>

<style>
#Home {
  /*background-color: #49a1a1;
  /*
  position: fixed;
  height: 100%;
  width: 100%;*/
}
#workspace {
  display: flex;
  width: 100%;
  height: 100%;
}
.div-50 {
  display: inline-flex;
  width: 50%;
  min-width: 50%;
}
</style>